import { render, staticRenderFns } from "./ProjectInvoicesDonationWarning.vue?vue&type=template&id=19a9aebf&scoped=true&"
import script from "./ProjectInvoicesDonationWarning.vue?vue&type=script&lang=js&"
export * from "./ProjectInvoicesDonationWarning.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInvoicesDonationWarning.vue?vue&type=style&index=0&id=19a9aebf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a9aebf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
installComponents(component, {VAlert})
